let numberFilter = (argu,num) => {
    if(argu == null || argu == "--"){
        return "--"
    }else {
        return Number(argu).toFixed(num);
    }
}
let subtractionFilter = (argu1,argu2,num) => {
    if(argu1 == null || argu2 == null){
        return '--';
    }else {
        return Number(argu1).toFixed(num);
    }
}
let stringFilter = (argu,num) => {
    if(argu == null){
        return "--"
    }else {
        if(argu.length > 10){
            return argu.substring(0,num) + "...";
        }else {
            return argu.substring(0,num);
        }
    }
}
let customFilter = (argu,num,type) => {
    if(argu == null || argu == "--"){
        return "--"
    }else if(type == 1){
        return Number(argu).toFixed(num)*1000;
    }else {
        return Number(argu).toFixed(num);
    }
}

let dateFormat = function(originVal) {
    const dt = new Date(originVal)

    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')

    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')

    return `${y}-${m}-${d}`
}
export {
    numberFilter,
    stringFilter,
    subtractionFilter,
    customFilter,
    dateFormat
}
